<template>
  <div class="page-wrapper">
    <alert-window ref="alertWindow"></alert-window>
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head worker-head">
              <div class="title">
                <router-link to="/workers-base">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{isNew ? 'Новый рабочий' : fullName}}
                <span class="block-text" v-if="worker.blocked || worker.dismiss">({{workerStatus}})</span>
              </div>
              <div class="block-button" v-if="!isNew && show" @click="blockOrUnblockWorker">
                {{worker.blocked ? 'Разблокировать' : 'Заблокировать'}}
              </div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility" v-if="!isNew && !dismiss && showDismissOrUndismissButton">
                      <span class="worker-lay-off" @click="dismissWorker"><i
                        class="fa fa-user-times"></i>Уволить рабочего</span>
                    </div>
                    <div class="head-panel visibility" v-if="dismiss && showDismissOrUndismissButton">
                      <span class="worker-lay-off" @click="undismissWorker"><i
                              class="fa fa-refresh"></i>Восстановить работника</span>
                    </div>


                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Фамилия</label>
                        <fieldset><input :disabled="!show" type="text" v-model="worker.surname"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Имя</label>
                        <fieldset><input :disabled="!show" type="text" v-model="worker.name"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Отчество</label>
                        <fieldset><input :disabled="!show" type="text" v-model="worker.patronymic"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Дата рождения</label>
                        <fieldset>
                          <date-picker
                                  v-model="worker.birthday"
                                  ref="workerBirthdayDatePicker"
                                  format="DD.MM.YYYY"
                                  lang="ru"
                                  v-mask="'##.##.####'"
                                  placeholder="__.__.____"
                                  :clearable="false"
                                  :first-day-of-week="1"
                                  :disabled="!show"
                                  @input="closeDate(worker.birthday, 'birthday')">
                          </date-picker>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Телефон</label>
                        <fieldset><input :disabled="!show" type="text" v-model="worker.phone" v-mask="'+7 (###) ###-##-##'"></fieldset>
                      </div>
                      <div class="fieldset dop-phones" v-for="(phone, index) in workerPhones">
                        <div class="phone-string">
                          <fieldset><input :disabled="!show" type="text" v-model="workerPhones[index].phone" v-mask="'+7 (###) ###-##-##'"></fieldset>
                          <span class="delete" title="Удалить" @click="removePhone(index)" v-if="show"><img
                            src="../image/cancel.svg"></span>
                        </div>
                      </div>
                      <div class="fieldset" v-if="show">
                        <div class="add-phone" @click="addPhone"><span class="icon">+</span>Добавить номер телефона
                        </div>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Район проживания</label>
                        <fieldset>
                          <select class="select-form" v-model="worker.district" :class="{'empty' : !show}" :disabled="!show">
                            <option hidden="" disabled="" selected="" :value="null">Выбрать район</option>
                            <option v-for="district in dto.districts" :value="district.id">
                              {{district.name}}
                            </option>
                          </select>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Тип рабочего</label>
                        <fieldset>
                          <select class="select-form worker-type-select" v-model="worker.workerType"
                                  @change="changeCategories(worker.workerType)" :class="{'empty' : !isNew}" :disabled="!isNew">
                            <option :value="null" hidden="" disabled="" selected="">Выбрать тип</option>
                            <option v-for="workerType in dto.workerTypes" :value="workerType.code">
                              {{workerType.name}}
                            </option>
                          </select>
                        </fieldset>
                      </div>
                      <div class="fieldset" v-if="worker.workerType !== null">
                        <label class="fieldset-title obligatorily">Категория</label>
                        <fieldset>
                          <ul class="checkbox-list">
                            <li v-for="trucking in dto.truckingCategories" v-if="worker.workerType === 'driver'">
                              <label class="checkbox-label"><input :disabled="!show" type="checkbox" :value="trucking.id"
                                                                   v-model="selectedCategoriesToWorker">{{trucking.name}}</label>
                            </li>
                            <li v-for="mover in dto.moverCategories" v-if="worker.workerType === 'mover'">
                              <label class="checkbox-label"><input :disabled="!show" type="checkbox" :value="mover.id"
                                                                   v-model="selectedCategoriesToWorker">{{mover.name}}</label>
                            </li>
                            <li v-for="furniture in dto.furnitureCategories" v-if="worker.workerType === 'furniture'">
                              <label class="checkbox-label"><input :disabled="!show" type="checkbox" :value="furniture.id"
                                                                   v-model="selectedCategoriesToWorker">{{furniture.name}}</label>
                            </li>
                            <li v-for="garbage in dto.garbageCategories" v-if="worker.workerType === 'garbage'">
                              <label class="checkbox-label"><input :disabled="!show" type="checkbox" :value="garbage.id"
                                                                   v-model="selectedCategoriesToWorker">{{garbage.name}}</label>
                            </li>
                          </ul>
                        </fieldset>
                      </div>
                      <div class="auto-datas" v-if="worker.workerType === 'driver'">
                        <div class="fieldset">
                          <label class="fieldset-title">Данные авто</label>
                          <fieldset><input :disabled="!show" type="text" v-model="worker.carNumber"></fieldset>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Габариты автомобиля, м.</label>
                          <div class="auto-size">
                            <fieldset><input :disabled="!show" type="text" placeholder="длина" v-model="worker.carLength"></fieldset>
                            <fieldset><input :disabled="!show" type="text" placeholder="ширина" v-model="worker.carWidth"></fieldset>
                            <fieldset><input :disabled="!show" type="text" placeholder="высота" v-model="worker.carHeight"></fieldset>
                          </div>
                        </div>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Дата устройства</label>
                        <fieldset>
                          <date-picker
                                  v-model="worker.employmentDate"
                                  ref="workerEmploymentDateDatePicker"
                                  format="DD.MM.YYYY"
                                  lang="ru"
                                  v-mask="'##.##.####'"
                                  placeholder="__.__.____"
                                  :clearable="false"
                                  :first-day-of-week="1"
                                  :disabled="!show"
                                  @input="closeDate(worker.employmentDate, 'employmentDate')">
                          </date-picker>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Рабочие смены</label>
                        <fieldset>
                          <ul class="work-time">
                            <li v-for="workingTime in dto.workingTimes">
                              <label class="checkbox-label"><input :disabled="!show" type="checkbox" :value="workingTime.id"
                                                                   v-model="worker.workerWorkingTimes">с
                                {{workingTime.fromHour}}.00 до
                                {{workingTime.toHour}}.00</label>
                            </li>
                          </ul>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title obligatorily">Рейтинг</label>
                        <fieldset><input :disabled="!show" type="number" v-model="worker.rating" min="1" max="5" v-mask="'#'"></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Комментарий</label>
                        <fieldset><textarea v-model="worker.comment"></textarea></fieldset>
                      </div>
                      <div class="dismissal-reason" v-if="!isNew && dismiss">
                        <div class="fieldset">
                          <label class="fieldset-title obligatorily">Дата увольнения</label>
                          <fieldset>
                            <date-picker
                                    v-model="worker.dismissDate"
                                    ref="workerDismissDateDatePicker"
                                    format="DD.MM.YYYY"
                                    lang="ru"
                                    v-mask="'##.##.####'"
                                    placeholder="__.__.____"
                                    :clearable="false"
                                    :first-day-of-week="1"
                                    @input="closeDate(worker.dismissDate, 'dismissDate')">
                            </date-picker>
                          </fieldset>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title obligatorily">Причина увольнения</label>
                          <fieldset><textarea v-model="worker.dismissReason"></textarea></fieldset>
                        </div>
                      </div>
                      <div class="buttons" v-if="show">
                        <button type="button" class="save-button" @click="save">Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import api from '@/api'
  import utils from '@/utils'
  import AlertWindow from '@/components/AlertWindow.vue'
  import DatePicker from 'vue2-datepicker'
  import {mask} from 'vue-the-mask'

  export default {
    name: 'Worker',
    components: {
      AlertWindow,
      MenuDispatcher,
      HeaderDispatcher,
      DatePicker
    },

    directives: {
      mask
    },

    data() {
      return {
        isNew: false,
        selectedCategoriesToWorker: [],
        workerPhones: [],
        dismiss: false,
        blocked: false,
        worker: {
          id: null,
          surname: '',
          name: '',
          patronymic: '',
          birthday: null,
          phone: null,
          employmentDate: null,
          rating: null,
          district: null,
          workerType: null,
          amountOfAccumulatedCollateral: null,
          carNumber: null,
          carHeight: null,
          carWidth: null,
          carLength: null,
          dismiss: false,
          workerWorkingTimes: [],
          categoriesToWorker: [],
          phones: [],
          dismissDate: null,
          dismissReason: null,
          userId: null,
          blocked: false,
          comment: null
        },
        dto: {
          districts: [],
          workerTypes: [],
          furnitureCategories: [],
          moverCategories: [],
          truckingCategories: [],
          garbageCategories: [],
          workingTimes: []
        }
      }
    },

    computed: {
      fullName() {
        return `${this.worker.surname + ' ' + this.worker.name + ' ' + this.worker.patronymic}`.trim();
      },
      workerStatus() {
        let dismissText = 'Уволен';
        let blockedText = 'Заблокирован';
        if (this.worker.dismiss && this.worker.blocked)
          return `${dismissText} и ${blockedText}`;
        else if (this.worker.dismiss)
          return dismissText;
        else if (this.worker.blocked)
          return blockedText;
        return '';
      },
      show() {
        return utils.checkRole(this.$store.getters.roleCode, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HR', 'ROLE_DISPATCHER']);
      },
      showDismissOrUndismissButton() {
        return utils.checkRole(this.$store.getters.roleCode, ['ROLE_SUPER_ADMIN']);
      },
    },

    mounted() {
      let body = document.getElementsByTagName("body")[0];
      body.classList.add("cabinet-page");
      this.addDatePickerWatchers();
      this.id = this.$route.params.id;
      if (this.id === 'new') {
        this.isNew = true;
        api.getDataForNewWorker().then(response => this.dto = response);
      } else if (/^\d+$/.test(this.id)) {
        api.getWorker(this.id)
          .then(response => {
            this.worker = response.first;
            this.dto = response.second;
            this.selectedCategoriesToWorker = this.worker.categoriesToWorker;
            this.workerPhones = this.worker.phones;
            this.dismiss = this.worker.dismiss;
            this.blocked = this.worker.blocked;
          })
          .catch(response => {
            alert(response);
            this.$router.push(`/workers-base/worker-card/new`);
            this.$router.go(0);
          })
      } else {
        this.$router.push(`/workers-base/worker-card/new`);
        this.$router.go(0);
      }
    },

    destroyed() {
      let body = document.getElementsByTagName("body")[0];
      body.classList.remove("cabinet-page");
    },

    methods: {
      addPhone() {
        this.workerPhones.push({
          id: null,
          phone: null
        });
      },
      removePhone(index) {
        this.workerPhones.splice(index, 1);
      },
      closeDate(date, fieldName) {
        let dateFormat = (/^\d+$/.test(date)) ? date : date.getTime();
        if (fieldName === 'birthday')
          this.worker.birthday = dateFormat;
        if (fieldName === 'employmentDate')
          this.worker.employmentDate = dateFormat;
        if (fieldName === 'dismissDate')
          this.worker.dismissDate = dateFormat;
      },
      changeCategories() {
        this.selectedCategoriesToWorker = [];
      },
      save() {
        if (this.$store.getters.waitingApiRequestsCount != 0)
          return;

        this.worker.categoriesToWorker = this.selectedCategoriesToWorker;
        this.worker.phones = this.workerPhones;
        this.worker.dismiss = this.dismiss;
        api
          .saveWorker(this.worker)
          .then(response => {
            this.worker.id = response.first;
            this.worker.userId = response.second;
            this.isNew = false;
            this.$router.push(`/workers-base/worker-card/${this.worker.id}`);
            this.$refs.alertWindow.show('Уведомление', 'Изменения сохранены')
          })
          .catch(response => {
            let errorMessage = '';
            for (let message of response) {
              errorMessage += `${message}<br>`
            }
            this.$refs.alertWindow.show('Ошибка сохранения', errorMessage)
          });
      },
      dismissWorker() {
        this.dismiss = true;
        this.$nextTick(() => {
          document.getElementsByClassName("directorys-page")[0].scrollTop =
            document.getElementsByClassName("directorys-page")[0].scrollHeight;
        });
      },
      undismissWorker() {
        this.dismiss = false;
      },
      blockOrUnblockWorker() {
        api
          .blockOrUnblockWorker(this.worker.id, !this.blocked)
          .then(response => {
            this.blocked = !this.blocked;
            this.worker.blocked = this.blocked;
            this.$refs.alertWindow.show('Уведомление', response.data.message);
          })
      },

      addDatePickerWatchers() {
        // нужны для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

        this.$watch(
          () => {
            return this.$refs.workerBirthdayDatePicker.userInput
          },
          (newVal, oldVal) => {
            let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
            if (tmpValueForDatePicker) {
              this.worker.birthday = tmpValueForDatePicker.valueOf();
              this.$refs.workerBirthdayDatePicker.popupVisible = false;
            } else if (tmpValueForDatePicker === null) {
              this.$refs.workerBirthdayDatePicker.userInput = '';
              this.$refs.workerBirthdayDatePicker.currentValue = null;
            }
          }
        );

        this.$watch(
          () => {
            return this.$refs.workerEmploymentDateDatePicker.userInput
          },
          (newVal, oldVal) => {
            let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
            if (tmpValueForDatePicker) {
              this.worker.employmentDate = tmpValueForDatePicker.valueOf();
              this.$refs.workerEmploymentDateDatePicker.popupVisible = false;
            } else if (tmpValueForDatePicker === null) {
              this.$refs.workerEmploymentDateDatePicker.userInput = '';
              this.$refs.workerEmploymentDateDatePicker.currentValue = null;
            }
          }
        );

        this.$watch(
          () => {
            return this.$refs.workerDismissDateDatePicker.userInput
          },
          (newVal, oldVal) => {
            let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
            if (tmpValueForDatePicker) {
              this.worker.dismissDate = tmpValueForDatePicker.valueOf();
              this.$refs.workerDismissDateDatePicker.popupVisible = false;
            } else if (tmpValueForDatePicker === null) {
              this.$refs.workerDismissDateDatePicker.userInput = '';
              this.$refs.workerDismissDateDatePicker.currentValue = null;
            }
          }
        );
      }
    }
  };
</script>
